import React from 'react';
import { useSelector } from 'react-redux';
import { Flex, Select, Typography, Input } from 'antd';

const { Text } = Typography;

export const TableCol = (handleSave) => {
  const _static = useSelector((state) => state.static);
  const { staticData } = _static;
  const { events } = staticData;

  const safeEvents = events ?? [];   // ✅ always an array

  return [
    {
      key: 'event',
      dataIndex: 'event',
      title: 'Event/s',
      render: (value, row) => {
        const _event = safeEvents.find((item) => item.id === value) ?? null;

        return (
          <Select
            style={{ width: '300px', minHeight: '64px' }}
            disabled
            options={safeEvents.map((event) => ({
              value: event.id,
              label: (
                <Flex vertical>
                  <Text>{event?.name}</Text>
                  <Text type="secondary">({event?.point} APA Points)</Text>
                </Flex>
              )
            }))}
            defaultValue={_event?.id}          // ✅ optional chaining on _event
            placeholder="Select a Event"
            onChange={(e) => handleSave({ ...row, event: e })}
          />
        );
      }
    },
    {
      key: 'detail',
      dataIndex: 'detail',
      title: 'Details',
      render: (value, row) => (
        <Input
          placeholder="Enter"
          value={value}
          disabled
          onChange={(e) => handleSave({ ...row, detail: e.target.value })}
        />
      )
    }
  ];
};